import React, { useEffect } from 'react'

import { Button, Col, Drawer, Form, Input, Row } from 'antd'

import { getServico, postServico, putServico } from '../../services/Servicos'

import { ItensPerUserLogged } from '../../services/login/permissaoUsuarioLoado'
import { destroyAlert, errorAlert, loadingAlert, successAlert } from '../../utils/alert'

interface TypesLaboratorio {
  update: number
  visible: boolean
  setOnClose: (data: boolean) => void
  setUpdate: (data: number) => void
  atualizar: () => void
  permissions: ItensPerUserLogged
}

const Laboratorio: React.FC<TypesLaboratorio> = (props) => {
  const { update, visible, setOnClose, setUpdate, atualizar, permissions } = props

  const [form] = Form.useForm()

  const hancleDrawerClose = () => {
    setOnClose(false)
    setUpdate(0)
    form.resetFields()
  }

  const handleChangeServico = async (data) => {
    loadingAlert({msg: 'Carregando serviço...', id: 'load_servico'});
    const response = await getServico(data === undefined ? '' : data)

    form.setFieldsValue(response.data.itens[0])
    destroyAlert('load_servico');
  }

  const onFinish = async (data) => {
    try {
      if (update === 0) {
        loadingAlert({msg: 'Salvando...', id: 'save_servico'});
        const response = await postServico(data)

        if (response.status === 201) {
          successAlert('Servico cadastrado com sucesso!', 5000, 'save_servico');
          form.resetFields()
          atualizar()
        }
      } else {
        loadingAlert({msg: 'Salvando...', id: 'save_servico'});
        const response = await putServico(update, data)

        if (response.status === 200) {
          successAlert('Servico atualizado com sucesso!', 5000, 'save_servico');
          atualizar()
        }
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response
        if (!data.error[0].field) {
          errorAlert(data?.error ?? 'Falha na operação!', 5000, 'save_servico');
        } else {
          data.error.forEach((data) => {
            errorAlert(data?.msg?.[0] ?? 'Falha na operação!', 5000, 'save_servico');
          })
        }
      }
      else {
        errorAlert('Falha na operação! (sem resposta)', 7000, 'save_ativos');
      }
    }
  }

  useEffect(() => {
    if (update !== 0) {
      handleChangeServico(update)
    }
  }, [update])

  return (
    <Form form={form} layout='vertical' onFinish={onFinish}>
      <Drawer
        title={update ? 'Atualizar Servico' : 'Cadastrar Servico'}
        style={{ position: 'absolute' }}
        placement='left'
        width='350px'
        onClose={hancleDrawerClose}
        open={visible}
        closeIcon={false}
        getContainer={false}
        footer={
          <div
            style={{
              textAlign: 'left',
            }}
          >
            <Button
              hidden={permissions?.inclusao === 0 && permissions?.alteracao === 0}
              type='primary'
              htmlType='submit'
            >
              {update ? 'Atualizar Ordem de serviço' : 'Salvar'}
            </Button>
            {'   '}
            <Button danger type='primary' onClick={hancleDrawerClose} style={{ marginRight: 8 }}>
              Fechar
            </Button>
          </div>
        }
      >
        <Col span={24}>
          <Row
            style={{
              pointerEvents: permissions?.acesso === 1 ? 'none' : 'auto',
            }}
            gutter={[8, 0]}
          >
            <Col flex='1 1 300px'>
              <Form.Item label='Nome' name='nome'>
                <Input />
              </Form.Item>
            </Col>
            <Col flex='1 1 200px'>
              <Form.Item label='Sigla' name='sigla'>
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Col>

        {/* Hiddenn */}

        <Form.Item initialValue='1' hidden name='status'>
          <Input />
        </Form.Item>
      </Drawer>
    </Form>
  )
}

export default Laboratorio
